'use client'

import * as React from 'react'
import { DataTable } from '@/components/data-table/data-table'
import { useDataTable } from '@/hooks/use-data-table'

import { useVariantsTableColumns } from './variants-table-columns'
import { VariantsTableSkeleton } from './VariantsTableSkeleton'
import { VariantsTableActionBar } from './variants-table-action-bar'
import { MainTableState } from '@/lib/utils/table-state-utils'
import type { TableConfig } from '@/types/data-table'
import { Product } from '@tagadapay/crm-entities'
import { DEFAULT_SKELETON_ROWS } from '@/config/data-table'

type VariantWithPrices = Product.ProductWithRelations['variants'][number]

interface VariantsTableProps {
    variants: VariantWithPrices[]
    productId: string
    storeId: string
    loading?: boolean
    config?: TableConfig
}

export const VariantsTable = ({
    variants,
    productId,
    storeId,
    loading = false,
    config = {},
}: VariantsTableProps) => {
    const [tableState, setTableState] = React.useState<MainTableState>({
        pagination: { pageIndex: 0, pageSize: 20 },
        sorting: [],
        columnFilters: [],
    })

    const columns = useVariantsTableColumns({ productId, storeId })

    const { table } = useDataTable({
        data: variants,
        columns,
        total: variants.length,
        config: { ...config, clientMode: true },
        onTableStateChange: setTableState,
        getRowId: (row: VariantWithPrices) => row.id,
        enableRowSelection: true,
    })

    return (
        <DataTable
            showToolbar={false}
            showFilters={false}
            table={table}
            isLoading={loading}
            skeletonRows={<VariantsTableSkeleton rows={config.skeletonRows || DEFAULT_SKELETON_ROWS} />}
            actionBar={<VariantsTableActionBar table={table} />}
        >
        </DataTable>
    )
}

